const reportssActionTypes = {
  SET_REPORTS: 'SET_REPORTS',
  SET_REPORTS_FETCHED_INFO: 'SET_REPORTS_FETCHED_INFO',
};
export default reportssActionTypes;
